import React from 'react';


const IconView = function(props) {
  const i = props.icon;
  const tx = -(1 + 34 * Math.floor(i % 40));
  const ty = -(1 + 34 * Math.floor(i / 40));

  const style = {
    height: '32px',
    width: '32px',
    display: 'inline-block',
    verticalAlign: 'middle',
    border: 'none',
    background: ("url('tiles.png') " + tx + "px " + ty + "px")
  };

  return <span style={style} />;
}


export default IconView;
